import { ID } from './common';
import { Event, EventPromptStatus } from './event';
import { FullConnection } from './connection';

export enum PromptType {
    NORMAL = 'NORMAL',
    TEMPORAL = 'TEMPORAL',
}

export enum PromptAttachmentType {
    PERSON = 'PERSON',
    OBJECT = 'OBJECT',
}

export interface Prompt {
    id: ID;
    createdAt: number;
    updatedAt: number;
    text: string;
    favorite: boolean;
    userId: ID;
    type: PromptType;
}

export interface PromptAttachment {
    id: ID;
    createdAt: number;
    updatedAt: number;
    type: PromptAttachmentType;
    url: string;
    promptId: ID;
}

export interface PromptEvent extends Event {
    confidence: number;
    status: EventPromptStatus;
    focuses: number[][];
}

interface PromptEventWithConnections extends PromptEvent {
    connections: FullConnection[];
}

export interface FullPrompt extends Omit<Prompt, 'userId'> {
    attachments: PromptAttachment[];
    events: PromptEvent[];
}

export interface FullPromptWithConnections extends Omit<FullPrompt, 'events'> {
    events: PromptEventWithConnections[];
}

export type PromptFilters = {
    createdAt?: number;
    favorite?: boolean;
    page?: number;
    size?: number;
};

export type CreatePromptPayload = Pick<Prompt, 'text' | 'favorite'> & {
    attachments: { type: PromptAttachmentType; url: string }[];
};

export type UpdatePromptPayload = Partial<Pick<Prompt, 'text' | 'favorite'>>;
